import {
  getBundleId,
  getBuildNumber,
  getVersion,
  isEmulator,
} from 'react-native-device-info';
import {
  isWeb,
  isNative,
  isAndroid,
  isIos,
  isWebPlatform,
} from '@global/screens';
import { convertPeriodFilter, convertYears } from '@global/helpers';

const bundleId = getBundleId();
const appVersion = getVersion();
const appVersionNumber = getBuildNumber();
let environment = 'development';
if (
  (isIos && bundleId == 'com.semesta-ios.nina') ||
  (isAndroid && bundleId == 'com.semesta.nina')
) {
  environment = 'production';
}

let IS_SIMULATOR = false;
if (isNative) {
  isEmulator().then((isSimulator) => {
    IS_SIMULATOR = isSimulator;
  });
}

export { IS_SIMULATOR };

export const ENV = environment;
export const VERSION = isNative ? `${appVersion} (${appVersionNumber})` : '';

export const INPUT_HEIGHT = isWeb ? 35 : 45;

export const ARROW_SIZE = {
  width: !isNative ? 12 : 16,
  height: !isNative ? 7 : 12,
};

export const CHECK_SIZE = {
  width: !isNative ? 16 : 16,
  height: !isNative ? 16 : 16,
};

export const ALLOWED_ATTACHMENT_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/heic',
  'image/heif',
  'image/svg+xml',
  'video/mp4',
  'application/pdf',
  'application/csv',
  'text/csv',
  'application/rar',
  'application/zip',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const ALLOWED_ATTACHMENT_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.mp4',
  '.gif',
  '.webp',
  '.heic',
  '.heif',
  '.pdf',
  '.csv',
  '.svg',
  '.xls',
  '.xlsx',
];

export const ATTACHMENT_FORMAT_ERROR_TITLE = 'Unsupported File Format';
export const ATTACHMENT_FORMAT_ERROR_DESCRIPTION =
  'Allowed file format: JPG, PNG, GIF, WEBP, HEIC, SVG, MP4, PDF, CSV, XLS, XLSX';

export const FILE_TYPE = {
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'application/pdf': 'pdf',
  'text/csv': 'csv',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'pptx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
};

export const CONSTANT = {
  special_expired_period: [
    {
      label: '15 Month',
      value: '15_month',
    },
    {
      label: '18 Month',
      value: '18_month',
    },
    {
      label: '24 Month',
      value: '24_month',
    },
  ],
  payment_terms: [
    {
      label: '14 Days',
      value: '14_days',
    },
    {
      label: '15 Days',
      value: '15_days',
    },
    {
      label: '21 Days',
      value: '21_days',
    },
    {
      label: '30 Days',
      value: '30_days',
    },
    {
      label: '40 Days',
      value: '40_days',
    },
    {
      label: '45 Days',
      value: '45_days',
    },
    {
      label: '60 Days',
      value: '60_days',
    },
    {
      label: 'Cash On Delivery',
      value: 'cash_on_delivery',
    },
  ],
  matrix_approval: [
    {
      label: 'Add Customer Approval',
      value: 'customer_credit_limit_add',
      type: 'amount',
      yup: {
        min_amount_label: 'Price value min',
        max_amount_label: 'Price value max',
      },
    },
    {
      label: 'Edit Customer Approval',
      value: 'customer_credit_limit_update',
      type: 'amount',
      yup: {
        min_amount_label: 'Price value min',
        max_amount_label: 'Price value max',
      },
    },
    // {
    //   label: 'Customer Credit Limit Approval',
    //   value: 'customer_credit_limit',
    //   type: 'amount',
    //   yup: {
    //     min_amount_label: 'Price value min',
    //     max_amount_label: 'Price value max',
    //   },
    // },
    // {
    //   label: 'Customer Cluster Approval',
    //   value: 'customer_cluster',
    //   type: 'role',
    //   yup: {
    //     applicable_on_label: 'Changed to',
    //   },
    // },
    {
      label: 'Sales Order Approval',
      value: 'sales_order',
      type: 'role',
      yup: {
        applicable_on_label: 'Created by',
        min_amount_label: 'Minimum Order',
      },
    },
    {
      label: 'Sales Activity Approval',
      value: 'sales_activity',
      type: 'role',
      yup: {
        applicable_on_label: 'Created by',
      },
    },
    {
      label: 'Budget Pocket Approval',
      value: 'budget_pocket',
      type: 'amount',
      yup: {
        min_amount_label: 'Budget value min',
        max_amount_label: 'Budget value max',
      },
    },
    {
      label: 'Target Sales Value Approval',
      value: 'target_sales_value',
      type: 'role',
      yup: {
        applicable_on_label: 'Target sales',
      },
      listing: [
        {
          label: 'National',
          value: 'national',
        },
        {
          label: 'Channel',
          value: 'channel',
        },
        {
          label: 'Branch',
          value: 'branch',
        },
        {
          label: 'Sales Team & Salesman',
          value: 'salesman',
        },
      ],
    },
    {
      label: 'Target Product Focus Approval',
      value: 'target_product_focus',
      type: 'role',
      yup: {
        applicable_on_label: 'Target product focus',
      },
      listing: [
        {
          label: 'Salesman Type',
          value: 'salesman',
        },
      ],
    },
    {
      label: 'Target DOORS Approval',
      value: 'target_doors',
      type: 'role',
      yup: {
        applicable_on_label: 'Target doors',
      },
      listing: [
        {
          label: 'National',
          value: 'national',
        },
        {
          label: 'Salesman',
          value: 'salesman',
        },
      ],
    },
    {
      label: 'Price List Approval',
      value: 'pricelist',
      type: 'role',
      yup: {
        applicable_on_label: 'Price list',
      },
      listing: [
        {
          label: 'Add',
          value: 'add',
        },
        {
          label: 'Edit',
          value: 'edit',
        },
      ],
    },
    {
      label: 'Promotion Rules Approval',
      value: 'promotion_rules',
      type: 'role',
      yup: {
        applicable_on_label: 'Promotion Rules',
      },
      listing: [
        {
          label: 'Regular Discount',
          value: 'regular_discount',
        },
        {
          label: 'Extra Discount',
          value: 'extra_discount',
        },
        {
          label: 'Buy X Get X And Buy X Get Y',
          value: 'buy_x_get_x_and_buy_x_get_y',
        },
        {
          label: 'Cash Before Delivery',
          value: 'cash_before_delivery',
        },
      ],
    },
    {
      label: 'Return Order Approval',
      value: 'order_return_approval',
      type: 'amount',
      yup: {
        min_amount_label: 'Return order min',
        max_amount_label: 'Return order max',
      },
    },
    {
      label: 'Promotion Agreement Approval',
      value: 'skp_approval',
      type: 'role',
      yup: {
        applicable_on_label: 'Promotion Agreement Type',
      },
      listing: [
        {
          label: 'Promotion Agreement Internal',
          value: 'skp_internal',
        },
        {
          label: 'Promotion Agreement External Taxable',
          value: 'skp_external_pkp',
        },
        {
          label: 'Promotion Agreement External Non Taxable',
          value: 'skp_external_non_pkp',
        },
      ],
    },
    {
      label: 'Budget Pocket',
      value: 'budget_pocket_type',
      type: 'role',
      yup: {
        applicable_on_label: 'Budget Pocket',
      },
      options: [
        {
          label: 'Add/Edit',
          value: 'add',
        },
        {
          label: 'Transfer',
          value: 'transfer',
        },
      ],
    },
    {
      label: 'GRN Approval',
      value: 'lpb_approval',
      type: 'role',
      yup: {
        applicable_on_label: 'GRN',
      },
      listing: [
        {
          label: 'Edit',
          value: 'edit',
        },
      ],
    },
    {
      label: 'Request Product Tester',
      value: 'request_product_tester',
      type: 'role',
      yup: {
        applicable_on_label: 'Request Product Tester',
      },
      listing: [
        {
          label: 'Add/Edit',
          value: 'add',
        },
      ],
    },
  ],
  matrix_type: ['amount', 'role'],
  matrix_approver: [
    {
      label: 'Sales Admin',
      value: 'sales_admin',
    },
    {
      label: 'Sales Supervisor',
      value: 'sales_supervisor',
    },
    {
      label: 'Finance Supervisor',
      value: 'finance_supervisor',
    },
    {
      label: 'Branch Head',
      value: 'branch_head',
    },
    {
      label: 'Regional Manager',
      value: 'regional_manager',
    },
    {
      label: 'Regional Support',
      value: 'regional_support',
    },
    {
      label: 'Key Account Manager',
      value: 'key_account_manager',
    },
    {
      label: 'Group Key Account Manager',
      value: 'group_key_account_manager',
    },
    {
      label: 'Distributor Manager',
      value: 'distributor_manager',
    },
    {
      label: 'General Manager',
      value: 'general_manager',
    },
    {
      label: 'Vice President',
      value: 'vice_president',
    },
    {
      label: 'Regional Distributor Manager',
      value: 'regional_distributor_manager',
    },
  ],
};

export const STATUS = {
  customer: [
    {
      label: 'Draft',
      value: 'draft',
      color: '#C7D1FF',
    },
    {
      label: 'Need Approval',
      value: 'need_approval',
      color: '#FAEFDC',
    },
    {
      label: 'Approved',
      value: 'approved',
      color: '#E2F7E4',
    },
    {
      label: 'Rejected',
      value: 'rejected',
      color: '#FCDCE3',
    },
  ],
  price_rules: [
    {
      label: 'Approved',
      value: 'approved',
      color: '#E2F7E4',
    },
    {
      label: 'Need Approval',
      value: 'need_approval',
      color: '#FAEFDC',
    },
    {
      label: 'Draft',
      value: 'draft',
      color: '#C7D1FF',
    },
    {
      label: 'Deleted',
      value: 'delete',
      color: '#FCDCE3',
    },
    {
      label: 'Updated',
      value: 'update',
      color: '#C7D1FF',
    },
    {
      label: 'Created',
      value: 'create',
      color: '#E2F7E4',
    },
    {
      label: 'Rejected',
      value: 'rejected',
      color: '#FCDCE3',
    },
  ],
  history_customer: [
    {
      label: 'Branch Head Approved',
      value: 'branch_head_approved',
      color: 'rgba(62, 234, 102, 0.08)',
    },
    {
      label: 'Distributor Manager Approved',
      value: 'distributor_manager_approved',
      color: 'rgba(62, 234, 102, 0.08)',
    },
    {
      label: 'General Manager Approved',
      value: 'general_manager_approved',
      color: 'rgba(62, 234, 102, 0.08)',
    },
    {
      label: 'Vice President Approved',
      value: 'vice_president_approved',
      color: 'rgba(62, 234, 102, 0.08)',
    },
    {
      label: 'Regional Distributor Manager Approved',
      value: 'regional_distributor_manager_approved',
      color: 'rgba(62, 234, 102, 0.08)',
    },
    {
      label: 'Branch Head Rejected',
      value: 'branch_head_rejected',
      color: 'rgba(252, 29, 103, 0.08)',
    },
    {
      label: 'Distributor Manager Rejected',
      value: 'distributor_manager_rejected',
      color: 'rgba(252, 29, 103, 0.08)',
    },
    {
      label: 'General Manager Rejected',
      value: 'general_manager_rejected',
      color: 'rgba(252, 29, 103, 0.08)',
    },
    {
      label: 'Vice President Rejected',
      value: 'vice_president_rejected',
      color: 'rgba(252, 29, 103, 0.08)',
    },
    {
      label: 'Regional Distributor Manager Rejected',
      value: 'regional_distributor_manager_rejected',
      color: 'rgba(252, 29, 103, 0.08)',
    },
    {
      label: 'Approved',
      value: 'approved',
      color: 'rgba(62, 234, 102, 0.08)',
    },
    {
      label: 'Pending Approval',
      value: 'need_approval',
      color: 'rgba(252, 177, 29, 0.08)',
    },
    {
      label: 'Draft',
      value: 'draft',
      color: 'rgba(29, 103, 252, 0.08)',
    },
    {
      label: 'Rejected',
      value: 'rejected',
      color: 'rgba(252, 29, 103, 0.08)',
    },
  ],
};

export const SALESMAN_TYPE = [
  {
    label: 'SE - Development',
    value: 'se_development',
  },
  {
    label: 'SE - Coverage',
    value: 'se_coverage',
  },
  {
    label: 'SE - Mix',
    value: 'se_mix',
  },
  {
    label: 'SE - BBS',
    value: 'se_bbs',
  },
  {
    label: 'SE - Haba',
    value: 'se_haba',
  },
  {
    label: 'SE - Non Haba',
    value: 'se_non_haba',
  },
  {
    label: 'SMD',
    value: 'smd',
  },
  {
    label: 'Spreading',
    value: 'spreading',
  },
];

export const SALESMAN_TYPE_OBJ = {
  se_development: 'SE - Development',
  se_coverage: 'SE - Coverage',
  se_mix: 'SE - Mix',
  se_bbs: 'SE - BBS',
  se_haba: 'SE - Haba',
  se_non_haba: 'SE - Non Haba',
  smd: 'SMD',
  spreading: 'Spreading',
};

export const MONTH_NAME = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTH_NAME_SIMPLE = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const BOOLEAN_STATUS = [
  { name: 'Active', value: true },
  { name: 'In Active', value: false },
];

export const YES_NO_STATUS = [
  { name: 'Yes', value: true },
  { name: 'No', value: false },
];

export const FLAG_TYPE = [
  { name: 'Best Seller', value: 'best_seller' },
  { name: 'New Arrival', value: 'new_arrival' },
];

export const BEST_SELLER_SCOPE = [
  { name: 'Sales Team', value: 'sales_team' },
  { name: 'Regional', value: 'regional' },
  { name: 'National', value: 'national' },
];

export const REGIONAL = [
  { name: 'East', value: 'east' },
  { name: 'West', value: 'west' },
];

export const CMS_PAGE_TYPE = [
  { name: 'Info', value: 'info' },
  { name: 'Promo', value: 'promo' },
];

export const CLUSTER_TYPE = [
  { name: 'Mega', value: 'mega' },
  { name: 'Ultimate', value: 'ultimate' },
  { name: 'Other', value: 'other' },
];

export const PAYMENT_TYPES = [
  { name: 'Cash', value: 'tunai' },
  { name: 'Giro/Cheque', value: 'giro' },
  { name: 'Transfer', value: 'transfer' },
];

export const PKP_TYPES = [
  { name: 'Taxable', value: true },
  { name: 'Non Taxable', value: false },
];

export const PAYMENT_TYPES_OBJ = {
  transfer: 'Transfer',
  giro: 'Giro/Cheque',
  tunai: 'Cash',
};

export const PKP_TYPES_OBJ = {
  true: 'Taxable',
  false: 'Non Taxable',
};

export const MAX_QUANTITY_FREE_PRODUCTS = [
  { name: 'Free per Bundle', value: 'bundle' },
  { name: 'Free per Product', value: 'product' },
];

export const FILTER_CHANNELS = [
  { label: 'GT', value: 'gt' },
  { label: 'MT', value: 'mt' },
];

export const FILTER_PERIOD = convertPeriodFilter(MONTH_NAME);

export const FILTER_YEARS = convertYears();

export const CUSTOMER_TYPES = [
  { label: 'Blank', value: 'blank' },
  { label: 'B2B VIP', value: 'b2b_vip' },
];

export const CUSTOMER_TYPES_OBJ = {
  b2b_vip: 'B2B VIP',
};

export const VISIT_DAYS = [
  { label: 'Monday', value: 'senin' },
  { label: 'Tuesday', value: 'selasa' },
  { label: 'Wednesday', value: 'rabu' },
  { label: 'Thursday', value: 'kamis' },
  { label: 'Friday', value: 'jumat' },
  { label: 'Saturday', value: 'sabtu' },
];

export const VISIT_DAYS_OBJ = {
  senin: 'Monday',
  selasa: 'Tuesday',
  rabu: 'Wednesday',
  kamis: 'Thursday',
  jumat: 'Friday',
  sabtu: 'Saturday',
};

export const VISIT_WEEKS = [
  { label: 'Week 1', value: 1 },
  { label: 'Week 2', value: 2 },
  { label: 'Week 3', value: 3 },
  { label: 'Week 4', value: 4 },
];

export const VISIT_WEEKS_OBJ = {
  1: 'Week 1',
  2: 'Week 2',
  3: 'Week 3',
  4: 'Week 4',
};

export const VISIT_FREQUENCIES = [
  { label: 'F1', value: 'f1' },
  { label: 'F2', value: 'f2' },
  { label: 'F4', value: 'f4' },
  { label: 'F8', value: 'f8' },
];

export const AUTOMATE_CREDIT_LIMIT = [
  {
    label: 'CL 1x of average sales / past 6 month',
    value: 'cl_1x_past_6months',
  },
  {
    label: 'CL 2x of average sales / past 6 month',
    value: 'cl_2x_past_6months',
  },
  {
    label: 'CL 2.5x of average sales / past 6 month',
    value: 'cl_2.5x_past_6months',
  },
  {
    label: 'CL 3x of average sales / past 6 month',
    value: 'cl_3x_past_6months',
  },
  { label: 'Not Set', value: 'not_set' },
];

export const WHT = [
  { label: 'Tax ID Corporate', value: 'npwp_badan' },
  { label: 'Tax ID Personal', value: 'npwp_pribadi' },
];

export const budget_pocket_type = [
  { name: 'Add/Edit', value: 'add' },
  { name: 'Transfer', value: 'transfer' },
];

export const COVER_AREA = [
  { name: 'Luar Kota', code: 'LK' },
  { name: 'Dalam Kota', code: 'DK' },
  { name: 'Luar Pulau', code: 'LP' },
];

export const NET_DOMAIN = [
  'nina.ptsemesta.id',
  'uat-b2b-external-apps.sociolabs.io',
];

export const QUOTATION_AMOUNT_THRESHOLD = 10000;

export const COOKIES_DOMAIN = isWebPlatform
  ? window.location.hostname.includes('sociolabs.io')
    ? '.sociolabs.io'
    : window.location.hostname.includes('ptsemesta.id')
    ? '.ptsemesta.id'
    : window.location.hostname.includes('localhost')
    ? '.localhost'
    : '.sociolla.info'
  : '';

export const COOKIES_EXPIRY = 365; // In days

export const WEB_SOURCE = ['b2b', 'b2b_vn'];

export const COA_TAX_SKP_FLOW_TYPE = [
  { label: 'Default', value: '' },
  { label: 'MT', value: 'mt' },
  { label: 'GT', value: 'gt' },
];

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*.])(?!.*\s)(?!.*(.)\1{2,})(?=.{8,}).*$/;

export const ORDER_TYPE = [
  { label: 'Direct', value: 'direct' },
  { label: 'Transfer', value: 'transfer' },
];

export const SPREADING_ORDER_TYPE = [
  { label: 'Spreading', value: 'spreading' },
];

export const CONSIGNMENT_ORDER_TYPE = [
  { label: 'Consignment Transfer', value: 'consignment_transfer' },
  { label: 'Consignment Sales Report', value: 'consignment_report' },
];
